import {translate} from '../helpers';

const showOrderTplType = (deliverType: string, orderTplType: string) => {
  if (['EXPRESS_POST', 'POST'].includes(deliverType)) {
    return 'پست پیشتاز';
  }
  if (deliverType == 'CHAPAR') {
    return 'چاپار';
  }
  if (!orderTplType || orderTplType == 'RONAD') {
    return 'پیک';
  }
  return translate(orderTplType, 'TPL');
};

export default showOrderTplType;
